import { useTranslation } from 'react-i18next';

import { BillingCurrency } from '@this+that/models';

import { getCurrencyForLanguage } from '../../utils/billing/resolveBillingCurrency';

export function useBillingCurrency(): BillingCurrency {
  const { i18n } = useTranslation();
  return getCurrencyForLanguage(i18n.language);
}
